<button
    (click)="update()"
    class="custom-action--button button -narrow hide-when-print"
    [title]="title"
    [disabled]="change.inFlight"
    >
  {{action.name}}
</button>
